<template>
    <div class="staff">
<!--      <el-card>-->
<!--        <el-breadcrumb separator="/">-->
<!--          <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>供应商管理</el-breadcrumb-item>-->
<!--          <el-breadcrumb-item>公司管理</el-breadcrumb-item>-->
<!--        </el-breadcrumb>-->
<!--      </el-card>-->
      <main class="content">
        <el-card>
          <el-form :inline="true" :model="searchForm" size="mini">
            <el-form-item label="供应商名称">
              <el-input v-model="searchForm.companyName" placeholder="供应商名称" size="mini" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
            </el-form-item>
          </el-form>
          <div ref="tablePosition"></div>
          <el-table
            size="mini"
            stripe
            :data="tableData"
            v-loading="loading"
            :height="tableConfig.height"
            style="width: 100%">
            <el-table-column
              width="200"
              fixed
              prop="companyName"
              label="供应商">
            </el-table-column>
            <el-table-column
              width="160"
              prop="manualSalePrice"
              label="手动输入销售价格">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.manualSalePrice ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.manualSalePrice ? '是' : '否'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="syncProduct"
              label="同步商品数据">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.syncProduct === 1 ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.syncProduct === 1 ? '在线' : '离线'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="syncOrder"
              label="同步订单数据">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.syncOrder === 1 ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.syncOrder === 1 ? '在线' : '离线'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="160"
              prop="syncOrderInfo"
              label="同步状态物流数据">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.syncOrderInfo === 1 ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.syncOrderInfo === 1 ? '在线' : '离线'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="shortName"
              label="公司简称">
            </el-table-column>
            <el-table-column
              width="120"
              prop="minimumDeliveryAmount"
              label="起送金额">
            </el-table-column>
            <el-table-column
              width="120"
              prop="minimumFreeShippingAmount"
              label="最低免邮金额">
            </el-table-column>
            <el-table-column
              width="200"
              prop="freight"
              label="不足最低免邮金额时运费">
            </el-table-column>
            <el-table-column
              width="300"
              prop="clientId"
              label="客户端ID">
            </el-table-column>
            <el-table-column
              width="300"
              prop="secretKey"
              label="密钥">
            </el-table-column>
            <el-table-column
              width="120"
              prop="internal"
              label="内部供应商">
              <template slot-scope="scope">
                {{scope.row.internal ? '是' : '否'}}
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              prop="reviewOrder"
              label="平台审核订单">
              <template slot-scope="scope">
                {{scope.row.reviewOrder ? '需要' : '不需要'}}
              </template>
            </el-table-column>
            <el-table-column
              width="80"
              prop="valid"
              label="是否有效">
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.valid ? 'primary' : 'info'"
                  disable-transitions>{{scope.row.valid ? "有效" : "无效" }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="160" align="right" fixed="right">
                <template slot="header">
                    <el-button type="primary" @click="showCreateDialog" size="mini">添加</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button type="text"
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-divider direction="vertical" ></el-divider>
                  <el-button
                    size="mini" type="text"
                    :disabled="scope.row.syncProduct !== 1 && scope.row.syncOrder !== 1 && scope.row.syncOrderInfo !== 1"
                    @click="handleEditApi(scope.$index, scope.row)">接口</el-button>
                </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;padding-top: 20px">
            <el-pagination
                background
                layout="sizes,prev, pager, next"
                :page-sizes="[10, 20, 50, 100]"
                v-if="total>0"
                :total="total"
                :page-size="pageSize"
                @size-change="handleSizeChange"
                @current-change="onPageChange"
                :current-page="currentPage"
                @prev-click="onPageChange"
                @next-click="onPageChange">
            </el-pagination>
          </div>
        </el-card>
      </main>
      <el-dialog title="维护供应商" :visible.sync="editDialogVisible" width="600px" :close-on-click-modal="false">
        <el-form ref="editForm"  :model="editForm" :inline="true" :rules="rules" label-width="100px">
          <div>
            <el-form-item label="公司" prop="companyId">
              <el-select v-model="editForm.companyId" filterable placeholder="请选择公司" :disabled="disbledCompany" size="small" clearable>
                <el-option
                  v-for="item in companyOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="'内部供应商" prop="internal">
              <el-switch v-model="editForm.internal"></el-switch>
            </el-form-item>
            <el-form-item label="手动售价" prop="manualSalePrice">
              <el-switch v-model="editForm.manualSalePrice"></el-switch>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <div>下单运费信息</div>
          <div>
            <el-form-item label="公司简称" prop="shortName">
              <el-input placeholder="请输入公司简称" v-model="editForm.shortName" maxlength="4" show-word-limit size="small" clearable></el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="起送金额" prop="minimumDeliveryAmount">
              <el-input placeholder="请输入起送金额" v-model="editForm.minimumDeliveryAmount" size="small" clearable>
                <template slot="prepend">￥</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="最低免邮金额" prop="minimumFreeShippingAmount">
              <el-input placeholder="请输入最低免邮金额" v-model="editForm.minimumFreeShippingAmount" size="small" clearable>
                <template slot="prepend">￥</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="不免邮运费" prop="freight">
              <el-input placeholder="请输入不足最低免邮金额时运费" v-model="editForm.freight" size="small" clearable>
                <template slot="prepend">￥</template>
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <div>信息在线同步</div>
          <div>
            <el-form-item label="商品" prop="syncProduct">
              <el-switch v-model="editForm.syncProduct"></el-switch>
            </el-form-item>
            <el-form-item label="下单" prop="syncOrder">
              <el-switch v-model="editForm.syncOrder"></el-switch>
            </el-form-item>
            <el-form-item label="状态物流" prop="syncOrderInfo">
              <el-switch v-model="editForm.syncOrderInfo"></el-switch>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="订单需审核" prop="reviewOrder">
              <el-switch v-model="editForm.reviewOrder"></el-switch>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="是否有效" prop="valid">
              <el-switch v-model="editForm.valid"></el-switch>
            </el-form-item>
          </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="接口配置" :visible.sync="editApiDialogVisible" width="600px" :close-on-click-modal="false">
            <el-form ref="editApiForm" :model="editApiForm" :rules="apiRules" label-width="90px">
                <div><strong>鉴权</strong></div>
                <el-form-item label="客户端ID" prop="clientId">
                    <el-input v-model="editApiForm.clientId" placeholder="请输入客户端ID" clearable></el-input>
                </el-form-item>
                <el-form-item label="密钥" prop="secretKey">
                    <el-input v-model="editApiForm.secretKey" placeholder="请输入密钥" clearable></el-input>
                </el-form-item>
                <el-form-item label="获取Token" prop="accessTokenUrl">
                    <el-input v-model="editApiForm.accessTokenUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.accessTokenMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="刷新Token" prop="refreshTokenUrl">
                    <el-input v-model="editApiForm.refreshTokenUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.refreshTokenMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
                <div><strong>订单</strong></div>
                <el-form-item label="统一下单" prop="orderUrl">
                    <el-input v-model="editApiForm.orderUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.orderMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认订单" prop="confirmOrderUrl">
                    <el-input v-model="editApiForm.confirmOrderUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.confirmOrderMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="取消订单" prop="cancelOrderUrl">
                    <el-input v-model="editApiForm.cancelOrderUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.cancelOrderMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="查询订单" prop="queryOrderUrl">
                    <el-input v-model="editApiForm.queryOrderUrl" placeholder="请输入URL" clearable>
                      <el-select v-model="editApiForm.queryOrderMethod" slot="prepend" placeholder="方法" style="width: 100px;" clearable>
                        <el-option label="GET" :value=0></el-option>
                        <el-option label="POST" :value=1></el-option>
                      </el-select>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editApiDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmitApi">确 定</el-button>
            </div>
        </el-dialog>
    </div>
  </template>
  <script>
  const HEIGHT_OFFSET = 118;
  export default {
    data() {
      return {
        pageLoading: undefined,
        tableConfig: {
              height: 0,
        },
        loading: false,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableData: [],
        editDialogVisible: false,
        searchForm: {
          companyName: "",
        },
        companyOptions: [],
        disbledCompany: false,
        editForm: {
          id: "",
          companyId: "",
          manualSalePrice: false,
          syncProduct: false,
          syncOrder: false,
          syncOrderInfo: false,
          internal: false,
          reviewOrder: true,
          shortName: '',
          minimumDeliveryAmount: 0,
          minimumFreeShippingAmount: 0,
          freight: 0,
          valid: true,
        },
        editApiForm: {
          companyId: "",
          clientId: "",
          secretKey: "",
          accessTokenUrl: "",
          refreshTokenUrl: "",
          orderUrl: "",
          confirmOrderUrl: "",
          cancelOrderUrl: "",
          queryOrderUrl: "",
          accessTokenMethod: undefined,
          refreshTokenMethod: undefined,
          orderMethod: undefined,
          confirmOrderMethod: undefined,
          cancelOrderMethod: undefined,
          queryOrderMethod: undefined,
        },
        editApiDialogVisible: false,
        rules: {
          companyId: [
            { required: true, message: '请输入公司代码', trigger: 'blur' }
          ],
          minimumDeliveryAmount: [
            { validator: (rule, value, callback) => {
              const numReg = /(^\d+$)|(^[0-9]+\.[0-9]{1,2}$)/;
              if(numReg.test(value)) {
                callback();
              } else {
                callback("请输入有效金额");
              }
            }, trigger: 'blur'}
          ]
        },
        apiRules: {
          clientId: [
            { required: true, message: '请输入客户端ID', trigger: 'blur' }
          ],
          secretKey: [
            { required: true, message: '请输入密钥', trigger: 'blur' }
          ],
          accessTokenUrl: [
            { required: true, message: '请输入获取Token URL', trigger: 'blur' }
          ],
          refreshTokenUrl: [
            { required: true, message: '请输入刷新Token URL', trigger: 'blur' }
          ],
          orderUrl: [
            { required: true, message: '请输入统一下单URL', trigger: 'blur' }
          ],
          confirmOrderUrl: [
            { required: true, message: '请输入确认订单URL', trigger: 'blur' }
          ],
          cancelOrderUrl: [
            { required: true, message: '请输入取消订单URL', trigger: 'blur' }
          ],
          queryOrderUrl: [
            { required: true, message: '请输入查询订单URL', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      onSearch() {
        this.loading = true;
        let that = this
        let param = {};
        if(this.searchForm.companyName) {
          param.companyName = this.searchForm.companyName;
        }
        this.$axios.post("/admin/supplier/searchCompany",{
            cond: param,
            page: this.currentPage - 1,size:this.pageSize
        }).then(function(response) {
            let resp = response.data;
            if(resp.header.status == 0) {
              that.loading = false;
              that.tableData = resp.data.content;
              that.total = resp.data.totalElements;
            }
        }).catch(function() {
          that.loading = false;
        });
      },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
      onPageChange(currentPage) {
        this.currentPage = currentPage;
        this.onSearch();
      },
      showCreateDialog() {
        let that = this;
        this.$axios.post("/admin/company/list",{})
        .then(function(response) {
          let resp = response.data;
          if(resp.header.status == 0) {
            that.companyOptions = resp.data;
            that.editForm = {
              id: "",
              companyId: "",
              manualSalePrice: false,
              syncProduct: false,
              syncOrder: false,
              syncOrderInfo: false,
              internal: false,
              reviewOrder: true,
              shortName: '',
              minimumDeliveryAmount: 0,
              minimumFreeShippingAmount: 0,
              freight: 0,
              valid: true,
            };
            that.disbledCompany = false;
            that.editDialogVisible = true;
          }
        }).catch(function() {
          that.loading = false;
        });
      },
      handleEdit(index, row) {
        let that = this;
        this.$axios.post("/admin/company/list",{})
        .then(function(response) {
          let resp = response.data;
          if(resp.header.status === 0) {
            that.companyOptions = resp.data;
            that.editForm = {
              ...row,
              syncProduct: row.syncProduct === 1,
              syncOrder: row.syncOrder === 1,
              syncOrderInfo: row.syncOrderInfo === 1,
            };
            that.disbledCompany = true;
            that.editDialogVisible = true;
          }
        }).catch(function() {
          that.loading = false;
        });
      },
      handleEditApi(index, row) {
        const that = this;
        this.$axios.get("/admin/supplier/openApi/" + row.companyId)
        .then(response => {
          const { data: resp } = response;
          if(resp.header.status === 0) {
            this.editApiForm = resp.data;
            that.editApiForm.companyId = row.companyId;
            that.editApiDialogVisible = true;
          }
        });
      },
      onSubmit() {
        let that = this;
        this.$refs.editForm.validate(valid => {
          if (valid) {
            let param = {
              ...this.editForm,
              syncProduct: this.editForm.syncProduct ? 1 : 0,
              syncOrder: this.editForm.syncOrder ? 1 : 0,
              syncOrderInfo: this.editForm.syncOrderInfo ? 1 : 0,
              minimumDeliveryAmount: Number.parseFloat(this.editForm.minimumDeliveryAmount),
              minimumFreeShippingAmount: Number.parseFloat(this.editForm.minimumFreeShippingAmount),
              freight: Number.parseFloat(this.editForm.freight),
            }
            this.$axios.post("/admin/supplier/saveCompany", param)
            .then(function(response) {
              let resp = response.data;
              if(resp.header.status == 0) {
                that.onSearch();
                that.editDialogVisible = false;
              }
            }).catch(function() {
            });
          }
        });
      },
      onSubmitApi() {
        const that = this;
        this.$refs.editApiForm.validate(valid => {
          if (valid) {
            this.$axios.post("/admin/supplier/saveOpenApi", this.editApiForm)
            .then(function(response) {
              let resp = response.data;
              if(resp.header.status == 0) {
                that.onSearch();
                that.editApiDialogVisible = false;
              }
            }).catch(function() {
            });
          }
        });
      },
      setTableHeight() {
          const tablePosition = this.$refs['tablePosition'];
          const {top} = tablePosition.getBoundingClientRect();
          this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
      }
    },
    created() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
    },
    mounted() {
          this.pageLoading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
              this.setTableHeight();
              this.pageLoading.close();
              this.pageLoading = undefined;
          }, 500);
      },
      beforeDestroy() {
          if(this.pageLoading){
              this.pageLoading.close();
              this.pageLoading = undefined;
          }
      },
      destroyed () {
          window.removeEventListener("resize", this.setTableHeight);
      }
  }
  </script>